module.exports = __webpack_public_path__ + "static/media/sos.59250da.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/liveVideo/sos.mp3
// module id = sQSL
// module chunks = 1